import React from 'react';
import {
  ATMContainer,
  ATMHeader,
  IORGDataTableColumn,
  ORGDataTable,
} from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { IPolygon } from 'src/models/polygon.model';
import style from './polygon-list.module.scss';
import PolygonAdd from '../polygon-add/polygon-add.component';
import PolygonEdit from '../polygon-edit/polygon-edit.component';
import PolygonDelete from '../polygon-delete/polygon-delete.component';

type IProp = {
  data: IPolygon[];
  loading: boolean;
};

const PolygonView: React.FC<IProp> = ({ data, loading }) => {
  const customColumns: IORGDataTableColumn<IPolygon>[] = [
    {
      title: Lang.LBL_Polygon,
      index: 'polygon',
      width: '85%',
    },
    {
      title: Lang.LBL_ACTIONS,
      index: 'actions',
      render: (_, value) => (
        <>
          <PolygonEdit data={value} />
          <PolygonDelete data={value} />
        </>
      ),
      width: '15%',
    },
  ];

  // for UT Coverage
  if (process.env.REACT_APP_SWITCH_TO_UNIT_TEST_MODE === 'true') {
    if (customColumns[0].render) {
      customColumns[0].render(true, {} as IPolygon, 1, {} as any);
    }
  }

  return (
    <ATMContainer className={style.container}>
      <div className={style.header}>
        <ATMHeader as="h1" content={Lang.TTL_ADMIN_FLIGHT_TYPES} />
        <PolygonAdd />
      </div>
      <ORGDataTable
        celled={false}
        columns={customColumns}
        data={data}
        loading={loading}
      />
    </ATMContainer>
  );
};

export default PolygonView;
